import { Controller } from "@hotwired/stimulus"

// Best-effort: writes browser coords into hidden inputs on connect. If the user
// denies permission or never responds, the form still submits with blank fields
// and the server treats the claim as locationless.
export default class extends Controller<HTMLElement> {
  static targets = ["latitude", "longitude"]

  declare readonly latitudeTarget: HTMLInputElement
  declare readonly longitudeTarget: HTMLInputElement
  declare readonly hasLatitudeTarget: boolean
  declare readonly hasLongitudeTarget: boolean

  connect() {
    if (!("geolocation" in navigator)) return
    if (!this.hasLatitudeTarget || !this.hasLongitudeTarget) return

    navigator.geolocation.getCurrentPosition(
      (position) => {
        this.latitudeTarget.value = String(position.coords.latitude)
        this.longitudeTarget.value = String(position.coords.longitude)
      },
      () => {},
      { enableHighAccuracy: false, timeout: 5000, maximumAge: 60000 }
    )
  }
}
